import React, { type ReactElement, useEffect, useState } from "react";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import { useI18next } from "gatsby-plugin-react-i18next";

import { getStoreIcons } from "@utilities/helper";

const AppDownloadSection = (): ReactElement => {
  const { t, language } = useI18next();

  const [appStoreIcon, setAppStoreIcon] = useState<string>("");
  const [playStoreIcon, setPlayStoreIcon] = useState<string>("");
  useEffect(() => {
    loadStoreIcons();
  }, []);
  const loadStoreIcons = () => {
    const { appStore, playStore } = getStoreIcons(language);
    setAppStoreIcon(appStore);
    setPlayStoreIcon(playStore);
  };

  return (
    <section className="mb-20 rounded-2xl bg-gradient-to-b from-primary-300 to-primary p-7 text-center">
      <h2 className="mb-6 text-xl md:text-3xl">{t("bnesim_esim_app_title")}</h2>
      <p className="text-lg font-semibold md:text-2xl">
        {t("bnesim_esim_app_sub_title")}
      </p>
      <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-7">
        <OutboundLink
          className="group h-[68px] w-max focus:outline-none"
          href={process.env.GATSBY_APP_STORE_LINK}
          aria-label="go to App Store"
          target="_blank"
        >
          {appStoreIcon ? (
            <img
              src={appStoreIcon}
              width={1920}
              height={600}
              className="h-full w-auto transition duration-300 group-hover:scale-105 group-focus:scale-95"
              alt="Download on the App Store"
            />
          ) : (
            <div className="h-full w-[210px] animate-pulse rounded-md bg-gray-200"></div>
          )}
        </OutboundLink>
        <OutboundLink
          className="group h-[68px] w-max focus:outline-none"
          href={process.env.GATSBY_PLAY_STORE_LINK}
          aria-label="go to Play Store"
          target="_blank"
        >
          {playStoreIcon ? (
            <img
              src={playStoreIcon}
              width={1920}
              height={600}
              className="h-full w-auto transition duration-300 group-hover:scale-105 group-focus:scale-95"
              alt="Get it on Google Play"
            />
          ) : (
            <div className="h-full w-[210px] animate-pulse rounded-md bg-gray-200"></div>
          )}
        </OutboundLink>
      </div>
    </section>
  );
};
export default AppDownloadSection;
